<template>
  <div class="port">
    <p>核酸检测</p>
    <div class="port-res" style="  background: linear-gradient(to bottom,#B7E860,#6DD437);"
         v-if="this.$route.query.result==='阴性'">
      <a href="#">您的新冠检测报告结果是</a>
      <h4>阴性</h4>
    </div>
    <div class="port-res" style="  background: linear-gradient(to right,#FF977A,#FF584A);"
         v-if="this.$route.query.result==='阳性'">
      <a href="#">您的新冠检测报告结果是</a>
      <h4>阳性</h4>
    </div>
    <p>检测报告</p>
    <div class="outport"  @click="getShow">
      <div class="report">
        <img src="../assets/image/pdf.png" alt="">
        <span>{{ filename }}</span>
        <img class="sorrow" src="../assets/image/sorrow.png" alt="">
        </div>
      <a class="createTime">报告日期:{{createTime}}</a></div>
  </div>
</template>

<script>

import {showReport} from '@/api/order/index.js';
import config from '../config';
export default {
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F4F4F4');
  },
  name: "port.vue",
  data() {
    return {
      form: {},
      filename: this.$route.query.name,
      createTime:this.$route.query.createTime
    };
  },
  created() {
    // this.getShow()
  },
  methods: {
    //展示
    getShow() {
      // let {baseApi} = config;
      // window.open(`${baseApi}upload/download/${this.$route.query.name}`,"_blank");
     this.$router.push({path: 'showPort', query: {name:this.$route.query.name}});
    },
  }
};
</script>

<style scoped lang='less'>
p {
  font-size: 48px;
  font-weight: bold;
  line-height: 6px;
  color: #232323;
  margin: 91px 0 50px 30px;
}

.port-res {
  width: 690px;
  height: 254px;
  margin: auto;
  border-radius: 10px;
  padding-top: 50px;

  a {
    font-size: 36px;
    color: #fff;
    line-height: 48px;
    margin-left: 146px;
    font-weight: bold;
  }

  h4 {
    font-size: 68px;
    line-height: 48px;
    font-weight: bold;
    color: #fff;
    margin-left: 278px;
  }
}

.report{
  width: 690px;
  margin: 0 auto;
  display: flex;
  font-size: 34px;
  justify-content:space-around;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;

  span {
    font-size: 30px;
    padding-left: 10px;
    padding-right: 30px;
    //margin-left: 20px;
  }

  img {
    width: 50px;
    height: 50px;
  }

  .sorrow {
    width: 15px;
    height: 26px;
  }
}
.createTime{
  font-size: 20px;
  color: #333333;
  position: absolute;
  left: 30px;

}
.outport{
  width: 690px;
  margin: 0 auto;
  height:160px;
  background-color: #fff;
  position: relative;
}
</style>
